module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.$route.name === 'InfoPage') ? _c('div', {
    staticStyle: {
      "background-color": "#fff",
      "margin": "0",
      "padding": "0"
    }
  }, [(!_vm.$store.state.auth.loggedIn) ? _c('app-info-page') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'InfoPage') ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.auth.loggedIn) ? _c('the-navigation-drawer') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('the-toolbar') : _vm._e(), _vm._v(" "), _c('app-alert'), _vm._v(" "), _c('v-main', {
    staticStyle: {
      "background-color": "#f3f5f7",
      "padding-bottom": "20px"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-icon btn-circle btn-success btn-scroll-to-top fade",
    staticStyle: {
      "background-color": "#2690cb !important"
    },
    attrs: {
      "href": "javascript:;",
      "data-click": "scroll-top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b758527","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2264
// module chunks = 1